module.exports = "<p>\r\n  transformer-monitoring works!\r\n</p>\r\n"